module.exports = __webpack_public_path__ + "static/media/Entreprise-Pilotage-Projets-Immobilier-Vaud.fc92a7b3.jpg";